import React from "react";

export function ProgressBar({ value, total, testId }) {
  const pct = total > 0 ? Math.min(100, Math.round((value / total) * 100)) : 0;
  return (
    <div>
      <div className="bb-progress-track" data-testid={testId || "progress-bar"}>
        <div className="bb-progress-fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-2 flex items-center justify-between text-xs text-[var(--bb-muted)]">
        <span>{value.toLocaleString()} of {total.toLocaleString()} books sponsored</span>
        <span className="font-medium text-[var(--bb-forest)]">{pct}%</span>
      </div>
    </div>
  );
}
